import { styled } from "@mui/material/styles";
import Div from "components/primitives/Div";

export const ProfileInputValue = styled(Div)({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  padding: "0 8px",
});
